import { Spinner } from '~/shadcn/ui/spinner'
import { PageContainer } from '~/@mid_ui/page-container/PageContainer'
import { HeadingThree } from '~/@mid_ui/typography/HeadingThree'
import { useIsDesktop } from '~/@mid_ui/layout/useIsDesktop'
import { useLocalNotifications } from '~/@mid_ui/local-notifications/useLocalNotifications'
import { AccountFundsButtons } from '~/@pages_account-portfolio/portfolio_components/account-funds-buttons/AccountFundsButtons'
import { useUser } from '~/@biz_account/useUser/useUser'
import { AddBankAccount } from './AddBankAccount'
import { BankAccountList } from './BankAccountList'

function BankAccountsPage() {
  const isDesktop = useIsDesktop()

  const { user, reloadUser } = useUser()
  const { setNotification } = useLocalNotifications()
  function handleAccountDeleted() {
    setNotification('success', 'Bankový účet bol odstránený')
    reloadUser()
  }

  function handleAccountAdded() {
    setNotification('success', 'Bankový účet bol pridaný')
    reloadUser()
  }

  if (user == null) return <Spinner className="size-6" />

  return (
    <div className="w-full pt-10 pb-15 flex flex-col last:grow">
      {isDesktop && (
        <PageContainer className="flex flex-col xl:flex-row items-start xl:items-center justify-between md:pl-40 md:pr-10 gap-4">
          <HeadingThree>Informácie o účte</HeadingThree>
          <AccountFundsButtons />
        </PageContainer>
      )}

      {!isDesktop && (
        <PageContainer className="py-8">
          <AccountFundsButtons />
        </PageContainer>
      )}

      <PageContainer className="md:mt-8 md:pl-40 md:pr-15">
        <BankAccountList user={user} onAccountDeleted={handleAccountDeleted} />
      </PageContainer>

      <PageContainer className="mt-8 md:pl-40 md:pr-15">
        <AddBankAccount user={user} onAccountAdded={handleAccountAdded} />
      </PageContainer>
    </div>
  )
}

export default BankAccountsPage
